import React, { useState } from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import useLocales from '../../hooks/useLocales';
import type { SelectOption } from '../../types/common';

const LanguageSelector = React.memo(() => {
  const { allLang, currentLang, onChangeLang } = useLocales();
  const { t } = useTranslation();
  const [selectedOption, setSelectedOption] = useState<SelectOption>(currentLang);

  /**
   * プルダウン選択肢のラベル表示関数
   * @param option[OptionsType] 選ばれた選択肢オブジェクト
   * @returns string ラベル文字列
   */
  const getOptionLabel = (option: SelectOption): string => t('language.' + option.label);

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  const handleSelectChange = (option): void => {
    setSelectedOption(option);
    onChangeLang(option.value);
  };

  // VIEW
  // ================================================================================

  return (
    <>
      <div style={{ maxWidth: '10rem' }}>
        <Select
          id="selectLanguage"
          value={selectedOption}
          options={allLang}
          onChange={handleSelectChange}
          placeholder="除外する需要家を選択して下さい"
          getOptionLabel={getOptionLabel}
          className="react-select-container"
          classNamePrefix="react-select"
        />
      </div>
    </>
  );
});

LanguageSelector.displayName = 'LanguageSelector';
export default LanguageSelector;
